import { IGetPropertyProgressDTO } from '@/models/propertyProgress.model';

class GetPropertyProgressDTO implements IGetPropertyProgressDTO {
  propertyId: string;

  constructor(id: string) {
    this.propertyId = id;
  }
}

export default GetPropertyProgressDTO;
